const state = {
  bankList: [],
}

const getters = {
  maxBankAccounts (state, getters, rootState) {
    let DG = 2
    const JY = 10
    // 20以內新增兩組 30三組 40四組 50上限五組 60可以刪除舊的
    const orderCount = rootState.userData.settings.statsJyorderCount || 0
    if (orderCount >= 50) {
      DG = 5
    } else if (orderCount >= 40) {
      DG = 4
    } else if (orderCount >= 30) {
      DG = 3
    }
    const user = rootState.userData
    // 1688 有訂單 且 淘寶沒有訂單 則可以新增99組
    const dgCan = Number(user.settings.statsDgorder1688Count) > 0 && Number(user.settings.statsDgorderTbCount) === 0
    if (dgCan) {
      DG = 99
    }
    return {
      JY,
      DG,
    }
  },
  canDeleteBank (state, getters, rootState) {
    return {
      DG: rootState.userData.settings.statsJyorderCount >= 60,
      JY: true,
    }
  },
}

const mutations = {
  setBankList (state, data) {
    state.bankList = data
  },
}

function splitRequestParams (params = {}) {
  const {
    config = {},
    ...requestParams
  } = params
  return {
    config,
    requestParams,
  }
}

const actions = {
  index ({ state, commit, rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.get('/wallet/profile/v1frontend/bkacct/index', {
      ...config,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL,
      params: requestParams,
    }).then(res => {
      commit('setBankList', res.data.list)
      return res
    })
  },
  create ({ state, commit, rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.post('/wallet/profile/v1frontend/bkacct/create', requestParams, {
      ...config,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
  delete ({ state, commit, rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.post('/wallet/profile/v1frontend/bkacct/delete', requestParams, {
      ...config,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
